import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Step1_Dates from '../pages/Step1_Dates';
import RoomSelection from '../pages/Step2_Room_Selection';
import ContactInfo from '../pages/Step3_Contact_Info';
import PaymentStep from '../pages/Step4_payment';
import ConfirmationPage from '../pages/Step5_Confirmation';
import ConfirmReservation from '../pages/ConfirmReservation';

export default function AppRoutes({ setStepNavigationProps }) {
  return (
    <Routes>
      {/* Booking Steps */}
      <Route path="/" element={<Step1_Dates setStepNavigationProps={setStepNavigationProps} />} />
      <Route path="/room" element={<RoomSelection setStepNavigationProps={setStepNavigationProps} />} />
      <Route path="/contact" element={<ContactInfo setStepNavigationProps={setStepNavigationProps}  />} />
      <Route path="/payment" element={<PaymentStep setStepNavigationProps={setStepNavigationProps} />} />
      <Route path="/confirmation" element={<ConfirmationPage setStepNavigationProps={setStepNavigationProps} />} />

      {/* Other standalone routes */}

      <Route path="/confirm-reservation/:reservationId" element={<ConfirmReservation />} />

     
    </Routes>
  );
}
